import request from '@/http/request'
import {
  downloadJobFileById,
  exportDownList, 
  getUnreadCount,
  updateReaded,
} from '@/http/api'
// 下载导出文件
export const downExportFileFn = (data) => {
  return request({
    url: downloadJobFileById,
    data
  })
}
// 获取导出的文件列表
export const getExportListFn = (data) => {
  return request({
    url: exportDownList,
    data
  })
}

export const getUnreadCountFn = (data) => {
  return request({
    url: getUnreadCount,
    data
  })
}

export const updateReadFn = (data) => {
  return request({
    url: updateReaded,
    data
  })
}
